(function () {
  'use strict';

  var EIRCODE_RE = /^[A-Z]\d[A-Z0-9]\s?[A-Z0-9]{4}$/i;
  var EIRCODE_KEY = 'de_eircode';
  var FLOW_KEY = 'de_flow_active';
  var POLL_INTERVAL = 500;
  var POLL_MAX = 10;
  var CRASH_TTL = 2 * 60 * 1000;

  var ROUTING_KEY_TO_COUNTY = {
    "A41":"Dublin","A42":"Dublin","A45":"Dublin","A63":"Wicklow","A67":"Wicklow",
    "A75":"Monaghan","A81":"Monaghan","A82":"Cavan","A83":"Meath","A84":"Meath",
    "A85":"Meath","A86":"Meath","A91":"Louth","A92":"Louth","A94":"Dublin",
    "A96":"Dublin","A98":"Wicklow","C15":"Meath","D01":"Dublin","D02":"Dublin",
    "D03":"Dublin","D04":"Dublin","D05":"Dublin","D06":"Dublin","D6W":"Dublin",
    "D07":"Dublin","D08":"Dublin","D09":"Dublin","D10":"Dublin","D11":"Dublin",
    "D12":"Dublin","D13":"Dublin","D14":"Dublin","D15":"Dublin","D16":"Dublin",
    "D17":"Dublin","D18":"Dublin","D20":"Dublin","D22":"Dublin","D24":"Dublin",
    "E21":"Tipperary","E25":"Tipperary","E32":"Tipperary","E34":"Tipperary",
    "E41":"Tipperary","E45":"Tipperary","E53":"Tipperary","E91":"Tipperary",
    "F12":"Mayo","F23":"Mayo","F26":"Mayo","F28":"Mayo","F31":"Mayo","F35":"Mayo",
    "F42":"Roscommon","F45":"Roscommon","F52":"Roscommon","F56":"Sligo","F91":"Sligo",
    "F92":"Donegal","F93":"Donegal","F94":"Donegal","H12":"Cavan","H14":"Cavan",
    "H16":"Cavan","H18":"Monaghan","H23":"Monaghan","H53":"Galway","H54":"Galway",
    "H62":"Galway","H65":"Galway","H71":"Galway","H91":"Galway","K32":"Dublin",
    "K34":"Dublin","K36":"Dublin","K45":"Dublin","K56":"Dublin","K67":"Dublin",
    "K78":"Dublin","N37":"Westmeath","N39":"Longford","N41":"Leitrim","N91":"Westmeath",
    "P12":"Cork","P14":"Cork","P17":"Cork","P24":"Cork","P25":"Cork","P31":"Cork",
    "P32":"Cork","P36":"Cork","P43":"Cork","P47":"Cork","P51":"Cork","P56":"Cork",
    "P61":"Cork","P67":"Cork","P72":"Cork","P75":"Cork","P81":"Cork","P85":"Cork",
    "R14":"Kildare","R21":"Carlow","R32":"Laois","R35":"Offaly","R42":"Offaly",
    "R45":"Offaly","R51":"Kildare","R56":"Kildare","R93":"Carlow","R95":"Kilkenny",
    "T12":"Cork","T23":"Cork","T34":"Cork","T45":"Cork","T56":"Cork","V14":"Clare",
    "V15":"Clare","V23":"Kerry","V31":"Kerry","V35":"Limerick","V42":"Limerick",
    "V92":"Kerry","V93":"Kerry","V94":"Limerick","V95":"Clare","W12":"Kildare",
    "W23":"Kildare","W34":"Kildare","W91":"Kildare","X35":"Waterford","X42":"Waterford",
    "X91":"Waterford","Y14":"Wicklow","Y21":"Wexford","Y25":"Wexford","Y34":"Wexford",
    "Y35":"Wexford"
  };

  function getCountyForEircode(pcNoSpace) {
    var key = pcNoSpace.substring(0, 3).toUpperCase();
    return ROUTING_KEY_TO_COUNTY[key] || 'Dublin';
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function formatPrice(raw) {
    return '€' + parseFloat(raw).toFixed(2);
  }

  function shippingQuery(pc, county) {
    return (
      'shipping_address%5Bzip%5D=' + encodeURIComponent(pc) +
      '&shipping_address%5Bcountry%5D=Ireland' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(county) +
      '&shipping_address%5Bfirst_name%5D=Estimator' +
      '&shipping_address%5Blast_name%5D=Quote'
    );
  }

  function cleanupShadowItems(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var idx = -1;
        for (var i = 0; i < items.length; i++) {
          var props = items[i].properties;
          if (props && props._estimator === 'true') { idx = i; break; }
        }
        if (idx === -1) { sessionStorage.removeItem(FLOW_KEY); cb(); return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: idx + 1, quantity: 0 }),
        })
          .then(function () { sessionStorage.removeItem(FLOW_KEY); cb(); })
          .catch(function () { sessionStorage.removeItem(FLOW_KEY); cb(); });
      })
      .catch(function () { sessionStorage.removeItem(FLOW_KEY); cb(); });
  }

  function crashRecovery() {
    var ts = sessionStorage.getItem(FLOW_KEY);
    if (!ts) return;
    if (Date.now() - parseInt(ts, 10) < CRASH_TTL) {
      cleanupShadowItems(function () {});
    } else {
      sessionStorage.removeItem(FLOW_KEY);
    }
  }

  // --- Widget ---

  function DeliveryEstimator(root) {
    this.root = root;
    this.variantId = root.dataset.variantId;
    this.postcodeEl = root.querySelector('input[type="text"]');
    this.qtyEl = root.querySelector('input[type="number"]');
    this.btnEl = root.querySelector('.delivery-estimator__btn');
    this.resultEl = root.querySelector('.delivery-estimator__result');
    // Stores {line: N, quantity: Q} of any pre-existing cart line for this variant
    this._savedLine = null;

    var saved = sessionStorage.getItem(EIRCODE_KEY);
    if (saved) this.postcodeEl.value = saved;

    this._bind();
    this._subscribeVariant();
  }

  DeliveryEstimator.prototype._bind = function () {
    var self = this;
    self.btnEl.addEventListener('click', function () { self._estimate(); });
    self.postcodeEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self._estimate(); }
    });
  };

  DeliveryEstimator.prototype._subscribeVariant = function () {
    var self = this;
    if (typeof subscribe !== 'function') return;
    subscribe('variant-change', function (event) {
      var v = event && event.data && event.data.variant;
      if (!v) return;
      self.variantId = String(v.id);
      self._setResult('');
    });
  };

  DeliveryEstimator.prototype._estimate = function () {
    var pc = (this.postcodeEl.value || '').trim().toUpperCase();
    var pcNoSpace = pc.replace(/\s+/g, '');
    var county = getCountyForEircode(pcNoSpace);
    var qty = Math.max(1, parseInt(this.qtyEl.value, 10) || 1);

    if (!EIRCODE_RE.test(pc)) {
      this._setResult(
        pc.length > 2
          ? '<p class="delivery-estimator__error">Please enter a valid Eircode (e.g. D6W F4E2).</p>'
          : ''
      );
      return;
    }

    var self = this;
    self._lockUI();
    sessionStorage.setItem(FLOW_KEY, String(Date.now()));
    self._setResult('<p class="delivery-estimator__loading">Checking rates\u2026</p>');

    // Step 1: zero out any existing cart line for this variant so Intuitive
    // Shipping only sees the estimator qty, not current qty + estimator qty.
    self._zeroExistingLine(qty, function () {
      self._addShadowItem(qty, function () {
        self._fetchRates(pcNoSpace, county, 0);
      });
    });
  };

  // Zero out any pre-existing non-shadow cart line for this variant.
  // Saves the line index + original qty so _restoreExistingLine can put it back.
  DeliveryEstimator.prototype._zeroExistingLine = function (qty, cb) {
    var self = this;
    self._savedLine = null;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var found = null;
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var props = item.properties || {};
          // Match variant, but skip shadow items (those we add ourselves)
          if (String(item.variant_id) === String(self.variantId) && props._estimator !== 'true') {
            found = { line: i + 1, quantity: item.quantity };
            break;
          }
        }
        if (!found) { cb(); return; }

        self._savedLine = found;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: found.line, quantity: 0 }),
        })
          .then(function () { cb(); })
          .catch(function () {
            // If we can't zero it, proceed anyway (estimate may be slightly off)
            self._savedLine = null;
            cb();
          });
      })
      .catch(function () { cb(); });
  };

  // Restore the zeroed-out cart line after the estimate is done.
  DeliveryEstimator.prototype._restoreExistingLine = function (cb) {
    var self = this;
    if (!self._savedLine) { cb(); return; }

    var saved = self._savedLine;
    self._savedLine = null;

    // Re-add the original item (the line number may have shifted after removing
    // the shadow item, so use add.js with the variantId rather than change.js).
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(self.variantId, 10), quantity: saved.quantity }],
      }),
    })
      .then(function () { cb(); })
      .catch(function () { cb(); });
  };

  DeliveryEstimator.prototype._lockUI = function () {
    this.root.classList.add('delivery-estimator--loading');
    this.btnEl.disabled = true;
    this.postcodeEl.disabled = true;
    this.qtyEl.disabled = true;
  };

  DeliveryEstimator.prototype._unlockUI = function () {
    this.root.classList.remove('delivery-estimator--loading');
    this.btnEl.disabled = false;
    this.postcodeEl.disabled = false;
    this.qtyEl.disabled = false;
  };

  DeliveryEstimator.prototype._addShadowItem = function (qty, cb) {
    var self = this;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(self.variantId, 10), quantity: qty, properties: { _estimator: 'true' } }],
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        return res.json();
      })
      .then(function () { cb(); })
      .catch(function (err) {
        console.error('[delivery-estimator] cart/add:', err);
        sessionStorage.removeItem(FLOW_KEY);
        self._restoreExistingLine(function () {
          self._unlockUI();
          self._setResult('<p class="delivery-estimator__error">Unable to retrieve delivery rates. Please try again.</p>');
        });
      });
  };

  DeliveryEstimator.prototype._fetchRates = function (pc, county, attempt) {
    var self = this;
    fetch('/cart/shipping_rates.json?' + shippingQuery(pc, county), { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 202) {
          if (attempt >= POLL_MAX) throw new Error('timeout');
          setTimeout(function () { self._fetchRates(pc, county, attempt + 1); }, POLL_INTERVAL);
          return null;
        }
        if (res.status === 422) throw new Error('unprocessable');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data === null) return;
        var rates = data && data.shipping_rates;
        self._cleanup(function () {
          self._renderRates(rates, pc);
        });
      })
      .catch(function (err) {
        var msg;
        if (err.message === 'timeout') {
          msg = '<p class="delivery-estimator__error">Rate calculation took too long. Please try again.</p>';
        } else if (err.message === 'unprocessable') {
          msg = '<p class="delivery-estimator__error">We couldn\'t find rates for this Eircode. Please check and try again.</p>';
        } else {
          msg = '<p class="delivery-estimator__error">Unable to retrieve delivery rates. Please try again.</p>';
        }
        self._cleanup(function () { self._setResult(msg); });
        console.error('[delivery-estimator] fetchRates:', err);
      });
  };

  DeliveryEstimator.prototype._cleanup = function (cb) {
    var self = this;
    cleanupShadowItems(function () {
      self._restoreExistingLine(function () {
        self._unlockUI();
        if (cb) cb();
      });
    });
  };

  DeliveryEstimator.prototype._renderRates = function (rates, pc) {
    if (!rates || !rates.length) {
      this._setResult(
        '<p class="delivery-estimator__no-rates">Estimated Delivery Cost: Calculated at checkout</p>'
      );
      return;
    }
    sessionStorage.setItem(EIRCODE_KEY, pc);
    var rate = rates[0];
    this._setResult(
      '<p class="delivery-estimator__rate-inline">Estimated Delivery Cost inc shipping and energy surcharge: ' +
      esc(formatPrice(rate.price)) + '</p>'
    );
  };

  DeliveryEstimator.prototype._setResult = function (html) {
    this.resultEl.innerHTML = html;
  };

  crashRecovery();

  document.querySelectorAll('.delivery-estimator').forEach(function (el) {
    new DeliveryEstimator(el);
  });
})();
